import { render } from "./UserProfileSetting.vue?vue&type=template&id=4bcb8403&scoped=true"
import script from "./UserProfileSetting.vue?vue&type=script&lang=js"
export * from "./UserProfileSetting.vue?vue&type=script&lang=js"

import "./UserProfileSetting.vue?vue&type=style&index=0&id=4bcb8403&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcb8403"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/UserProfileSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bcb8403"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bcb8403', __exports__)) {
    api.reload('4bcb8403', __exports__)
  }
  
  module.hot.accept("./UserProfileSetting.vue?vue&type=template&id=4bcb8403&scoped=true", () => {
    api.rerender('4bcb8403', render)
  })

}


export default __exports__